import _concat from "lodash/concat";
import _sortBy from "lodash/sortBy";
import { FacetCategories } from "models";
import {
  IBasicInfoViewModel,
  IFacetCategoryViewModel,
  IFacetsViewModel,
  IFacetViewModel,
} from "pages/MainPage/components/BasicInfoSection/viewModels";
import { ConverterBasicInfo } from "./types";

const GENDER_CODES_IN_PRIORITY = [
  "Gender_Other_Custom",
  "Gender_Other_NonBinary",
  "Gender_Other_Transgenderfemale",
  "Gender_Other_Transgendermale",
  "Gender_Other_Male",
  "Gender_Other_Female",
];

function applyGenderPriority(
  selectedGenderFacets: IFacetViewModel[]
): Partial<IBasicInfoViewModel> {
  if (selectedGenderFacets.length === 0) {
    return {};
  }

  const genderFacet = GENDER_CODES_IN_PRIORITY.map((code) =>
    selectedGenderFacets.find((facet) => facet.code === code)
  ).find(Boolean);

  return genderFacet ? { genders: [genderFacet.name] } : {};
}

export function mapFacets(
  basicInfo: ConverterBasicInfo,
  facets: IFacetsViewModel
): Partial<IBasicInfoViewModel> &
  Pick<
    IBasicInfoViewModel,
    "ethnicBackground" | "heritageAndEthnicity" | "ethnicity"
  > {
  let result: Partial<IBasicInfoViewModel> = {};
  const selectedGenderFacets: IFacetViewModel[] = [];

  _sortBy(basicInfo.facets, "position").forEach((selectedFacet) => {
    Object.values(facets).forEach((category: IFacetCategoryViewModel) => {
      const facet = category.facets.find(
        (item) => item.id === selectedFacet.facetId
      );

      if (!facet) {
        return;
      }

      switch (category.systemName) {
        case FacetCategories.MembershipBodies:
          result = {
            ...result,
            memberships: _concat(result.memberships ?? [], facet.name),
          };

          return;
        case FacetCategories.Nationality:
          result = {
            ...result,
            nationalities: _concat(result.nationalities ?? [], facet.name),
          };

          return;
        case FacetCategories.Appearance:
          result = {
            ...result,
            appearances: _concat(result.appearances ?? [], facet.name),
          };

          return;
        case FacetCategories.Disability:
          result = {
            ...result,
            disabilities: _concat(result.disabilities ?? [], facet.name),
          };

          return;
        case FacetCategories.HeritageAndEthnicity:
          result = {
            ...result,
            heritageAndEthnicity: _concat(
              result.heritageAndEthnicity ?? [],
              facet.name
            ),
          };

          return;
        case FacetCategories.EthnicBackground:
          result = {
            ...result,
            ethnicBackground: _concat(
              result.ethnicBackground ?? [],
              facet.name
            ),
          };

          return;
        case FacetCategories.VoiceStyle:
          result = {
            ...result,
            voiceStyle: _concat(result.voiceStyle ?? [], facet.name),
          };

          return;
        case FacetCategories.VisasAndWorkingPermits:
          result = {
            ...result,
            visasAndPermits: _concat(result.visasAndPermits ?? [], facet.name),
          };

          return;
        case FacetCategories.EyeColour:
          result = { ...result, eyeColor: facet.name };

          return;
        case FacetCategories.HairColour:
          result = { ...result, hairColor: facet.name };

          return;
        case FacetCategories.HairLength:
          result = { ...result, hairLength: facet.name };

          return;
        case FacetCategories.FacialHair:
          result = { ...result, facialHair: facet.name };

          return;
        case FacetCategories.Gender:
          selectedGenderFacets.push(facet);

          return;
        default:
          return;
      }
    });
  });

  return {
    ...result,
    ...applyGenderPriority(selectedGenderFacets),
    ethnicBackground: result.ethnicBackground ?? [],
    heritageAndEthnicity: result.heritageAndEthnicity ?? [],
    ethnicity: result.ethnicity ?? [],
  };
}
